import { Button } from 'src/v2/commonComponents/Button';
import styles from './ConversationFooter.module.scss';
import { ArrowUp } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { Icon } from 'src/components/Icon';
import {
  useConversationActions,
  useConversations,
  useConversationsIsCollapsed,
  useScrollToTopConversations,
} from 'src/hooks';
import { useContext, useEffect, useState } from 'react';
import ForwardRefContext from 'src/contexts/ForwardRefContext';

export const ConversationFooter = () => {
  const { scrollableConversationsContainerRef } = useContext(ForwardRefContext);

  const [scrolledToBottom, setScrolledToBottom] = useState<boolean>(false);
  const [isButtonScrollUpVisible, setIsButtonScrollUpVisible] = useState(false);

  const { conversations = [], newPageToken } = useConversations();

  const { handleScroll } = useScrollToTopConversations();
  const { isConversationListCollapsed } = useConversationsIsCollapsed();
  const { setPageToken, toggleConversationListCollapse } =
    useConversationActions();

  useEffect(() => {
    const scrollRef = scrollableConversationsContainerRef?.current;

    const onConversationsScroll = () => {
      const {
        scrollTop = 0,
        clientHeight = 0,
        scrollHeight = 0,
      } = scrollRef || {};

      setIsButtonScrollUpVisible(scrollTop > 30);

      if (!scrolledToBottom) {
        if (scrollTop + clientHeight >= scrollHeight) {
          setScrolledToBottom(true);
        }
      }
    };

    scrollRef?.addEventListener('scroll', onConversationsScroll);

    return () => {
      scrollRef?.removeEventListener('scroll', onConversationsScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (conversations.length === 0) {
      setScrolledToBottom(false);
    }

    if (scrolledToBottom && newPageToken) {
      if (newPageToken) {
        setPageToken(newPageToken);
      }

      setScrolledToBottom(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrolledToBottom]);

  const handleScrollToTopClick = () => {
    handleScroll({
      direction: 'up',
      scrollableContainerRef: scrollableConversationsContainerRef,
    });
  };

  const handleShowHideTasksClick = () => {
    toggleConversationListCollapse();
  };

  if (!conversations.length) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Button
        color="transparent"
        size="small"
        onClick={handleShowHideTasksClick}
      >
        <Icon
          type={isConversationListCollapsed ? 'caretDownUp' : 'caretUpDown'}
          size={SVG_SIZE_M}
        />
        {!!isConversationListCollapsed ? 'Hide tasks' : 'Show tasks'}
      </Button>

      <Button
        color="transparent"
        size="small"
        onClick={handleScrollToTopClick}
        disabled={!isButtonScrollUpVisible}
      >
        <ArrowUp />
        Back to top
      </Button>
    </div>
  );
};
